export default __webpack_public_path__ + "static/media/le_croise14.26ce48b4.jpg";